import React from 'react'
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppFloat = () => {
  return (
    <div>
         <a
       href="https://wa.me/917668384694"  
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp />
    </a>
    </div>
  )
}

export default WhatsAppFloat